// NOTE: this is a temporary solution to fix the issue connected with authorization
// inside webview due to different auth approach; without this code the webview will
// not be able to access the site designer
import { useAuth } from '@fourthwall/auth';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
export const useMobileCookies = (deps) => {
    const { keycloak } = useAuth();
    const accessTokenAttributes = {
        sameSite: 'lax',
        secure: true,
    };
    const refreshTokenAttributes = {
        sameSite: 'strict',
        secure: true,
    };
    useEffect(() => {
        // @ts-ignore
        Cookies.set('creator_access_token', keycloak?.token, {
            ...accessTokenAttributes,
        });
        Cookies.set('creator_refresh_token', keycloak?.refreshToken, {
            ...refreshTokenAttributes,
        });
    }, deps);
};
